import type { trpc } from "@/lib/trpc";
import type { inferInput, inferOutput } from "@trpc/tanstack-react-query";
import { RouterOutputs } from "@papier/api";

export type ProjectOutput = inferOutput<typeof trpc.projects.getAll>[number];
export type ProjectBySlugOutput = RouterOutputs["projects"]["getBySlug"];

export type EnvironmentOutput = ProjectBySlugOutput["environments"][number];

export type ProjectTemplateOutput = inferOutput<typeof trpc.templates.getAllWithUserDrafts>[number];

export type TemplatePreviewOutput = inferOutput<typeof trpc.templates.getPublishedTemplate>;

export type ApiKeyOutput = inferOutput<typeof trpc.apiKeys.getAll>[number];

export type UserOutput = inferOutput<typeof trpc.authTrpc.getAdminUsers>["users"][number];
export type GetAdminUsersInput = inferInput<typeof trpc.authTrpc.getAdminUsers>;

export type OrganizationOutput = inferOutput<
  typeof trpc.authTrpc.getAdminOrganizations
>["organizations"][number];
export type GetAdminOrganizationsInput = inferInput<typeof trpc.authTrpc.getAdminOrganizations>;

export type AdminUserActionsDialog =
  | "role"
  | "setPassword"
  | "revokeSessions"
  | "ban"
  | "unban"
  | "delete";

export type AdminOrgActionsDialog = "delete" | "add-members";

export const authViewPaths = {
  SIGN_IN: "sign-in",
  SIGN_UP: "sign-up",
  SIGN_OUT: "sign-out",
  MAGIC_LINK: "magic-link",
  FORGOT_PASSWORD: "forgot-password",
  RECOVER_ACCOUNT: "recover-account",
  CALLBACK: "callback",
  EMAIL_OTP: "email-otp",
  RESET_PASSWORD: "reset-password",
  TWO_FACTOR: "two-factor",
  ACCEPT_INVITATION: "accept-invitation",
  ORGANIZATION: "organization",
} as const;

export type AuthViewPath = (typeof authViewPaths)[keyof typeof authViewPaths];

export const nonAuthViews: AuthViewPath[] = [
  authViewPaths.SIGN_IN,
  authViewPaths.SIGN_UP,
  authViewPaths.MAGIC_LINK,
  authViewPaths.FORGOT_PASSWORD,
  authViewPaths.RECOVER_ACCOUNT,
  authViewPaths.CALLBACK,
];
